module.exports = __webpack_public_path__ + "static/media/hiw21.da77a0bf.svg";